module.exports = __webpack_public_path__ + "img/icon_heart_8.4d3b94fa.svg";